import { createAsyncThunk } from '@reduxjs/toolkit'
import { SecurityGroupsServerData } from '@lk/api'

import { actions as LKActions } from '../../../features/shared/LKModal'
import { ThunkApi } from '../../index.d'

export const loadSecurityUserGroups = createAsyncThunk<SecurityGroupsServerData, void, ThunkApi>(
  '[SECURITY] LOAD_SECURITY_USER_GROUPS',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.security.groups()

    if (result.success) {
      return result.data
    }

    dispatch(LKActions.openError(result.error.message))

    return rejectWithValue(result.error.message)
  },
)
